export const skills = {
  Proficient: ["Java", "JavaScript", "React.js", "HTML5", "CSS3", "MySQL"],
  Familiar: [
    "Python",
    "REST API Basics",
    "Azure Data Factory",
    "Azure Databricks",
    "Power BI",
  ],
};
